<script>
  import { assets } from '$app/paths';
  import Visible from '$lib/components/Visible.svelte';
</script>

<Visible top="-60" let:visible>
  <div class="headline-ender-container">
    {#if visible}
      <div class:show-sketch={true} id="red-carpet"></div>
      <div class="rihanna-container">
        <img
          class:show-sketch={true}
          class="rihanna-sketch-2023"
          src="{assets}/images/rihanna-assets/rihanna-sketches/2023-rihanna-sketch.png"
          alt=""
        />
        <img
          class="rihanna-cutout-2023"
          src="{assets}/images/rihanna-assets/rihanna-cutouts/2023-rihanna-cut.png"
          alt=""
        />
      </div>
      <p class:show-sketch={true} class="headline-ender-text">
        on the red carpet
      </p>
    {:else}
      <div class:hide-sketch={true} id="red-carpet"></div>
      <div class="rihanna-container">
        <div class="rihanna-container">
          <img
            class:hide-sketch={true}
            class="rihanna-sketch-2023"
            src="{assets}/images/rihanna-assets/rihanna-sketches/2023-rihanna-sketch.png"
            alt=""
          />

          <img
            class="rihanna-cutout-2023"
            src="{assets}/images/rihanna-assets/rihanna-cutouts/2023-rihanna-cut.png"
            alt=""
          />
        </div>
      </div>
      <p class:hide-sketch={true} class="headline-ender-text">
        on the red carpet
      </p>
    {/if}
  </div>
</Visible>

<style lang="scss">
  .headline-ender-container {
    position: relative;
    width: 100%;
    height: 750px;
    overflow: hidden;
    #red-carpet {
      width: 100%;
      height: 348px;
      background-color: var(--tr-dark-red);
      position: absolute;
      bottom: 13%;
      z-index: 2;
      opacity: 0;
      &.show-sketch {
        opacity: 1;
        animation: fadeIn 0.9s ease-in-out;
      }
      &.hide-sketch {
        opacity: 0;
        animation: fadeOut 0.5s ease-in-out;
      }
    }
    .rihanna-container {
      width: 1200px;
      position: absolute;
      bottom: 0%;
      z-index: 3;
      left: 50%;
      transform: translateX(-50%);
      .rihanna-cutout-2023 {
        max-width: 875px;
        margin-left: 20%;
      }
      .rihanna-sketch-2023 {
        max-width: 875px;
        margin-left: 20%;
        opacity: 0;
        position: absolute;
        &.show-sketch {
          opacity: 1;
          animation: fadeIn 0.9s ease-in-out;
        }

        &.hide-sketch {
          opacity: 0;
          animation: fadeOut 0.5s ease-in-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fadeOut {
          from {
            opacity: 1;
          }
          to {
            opacity: 0;
          }
        }
      }
    }
    .headline-ender-text {
      font-family: 'BethEllen-Regular';
      font-size: var(--theme-font-size-4xl);
      color: var(--tr-black);
      position: absolute;
      bottom: -15px;
      z-index: 3;
      left: 40%;
      &.show-sketch {
        opacity: 1;
        animation: fadeIn 0.9s ease-in-out;
      }

      &.hide-sketch {
        opacity: 0;
        animation: fadeOut 0.5s ease-in-out;
      }
    }
  }

  @media (max-width: 1214px) {
    .headline-ender-container {
      #red-carpet {
        bottom: 17%;
        height: 324px;
      }
      .rihanna-container {
        width: 930px;
        bottom: 6%;

        .rihanna-cutout-2023 {
          max-width: 798px;
          margin-left: 12.5%;
        }
        .rihanna-sketch-2023 {
          max-width: 798px;
          margin-left: 12.5%;
        }
      }
      .headline-ender-text {
        font-size: calc(1.1 * var(--theme-font-size-3xl));
        bottom: 0px;
        left: 36%;
      }
    }
  }

  @media (max-width: 944px) {
    .headline-ender-container {
      height: 640px;
      #red-carpet {
        bottom: 21.9%;
      }
      .rihanna-container {
        width: 660px;

        .rihanna-cutout-2023 {
          max-width: 710px;
          margin-left: 11.5%;
        }
        .rihanna-sketch-2023 {
          max-width: 710px;
          margin-left: 11.5%;
        }
      }
      .headline-ender-text {
        bottom: 5px;
        left: 40%;
      }
    }
  }
  @media (max-width: 674px) {
    .headline-ender-container {
      height: 480px;
      #red-carpet {
        bottom: 23.5%;
        height: 204px;
      }
      .rihanna-container {
        width: 510px;

        .rihanna-cutout-2023,
        .rihanna-sketch-2023 {
          max-width: 515px;
        }
      }
      .headline-ender-text {
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
      }
    }
  }

  @media (max-width: 524px) {
    .headline-ender-container {
      height: 315px;
      #red-carpet {
        bottom: 22.5%;
        height: 151px;
      }
      .rihanna-container {
        width: 330px;
        bottom: 0%;

        .rihanna-cutout-2023,
        .rihanna-sketch-2023 {
          max-width: 342px;
          margin-left: 12%;
        }
      }
      .headline-ender-text {
        bottom: -10px;
        font-size: var(--theme-font-size-3xl);
      }
    }
  }
</style>
